<div class="rpu">
  <div class="rpu-pagehead">
    <div class="rpu-pagehead-icon" aria-hidden="true">
      <svg viewBox="0 0 16 16" width="22" height="22" fill="currentColor"><path d="M1.5 14a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v8.44l3.3-3.3a.75.75 0 0 1 1.02-.04l2.4 2.03 3.9-4.13H10.5a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V7.1l-4.4 4.66a.75.75 0 0 1-1.03.06L5.9 9.78 2.25 13.4a.75.75 0 0 1-.53.22Z"/></svg>
    </div>
    <div>
      <div class="rpu-h1">Resource usage</div>
      <div class="rpu-desc">
        Workload per resource across all tasks, spread over each resource's working calendar and its timephased work.
        Weekends and holidays carry no load. Cells turn red when allocation exceeds the resource's available Max Units.
      </div>
    </div>
  </div>

  <div class="rpu-flash -error" *ngIf="error">{{ error }}</div>
  <div class="rpu-loading" *ngIf="loading">
    <span class="rpu-spinner" aria-hidden="true"></span>Loading resource usage…
  </div>

  <ng-container *ngIf="!loading && !error">
    <!-- summary -->
    <div class="rpu-summary">
      <div class="rpu-card -accent">
        <div class="uc-ico" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor"><path d="M5.5 3.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 12.25c0-1.79 1.7-3.25 3.5-3.25S9 10.46 9 12.25V13H2v-.75Zm8.5-3.25c1.8 0 3.5 1.46 3.5 3.25V13h-4.06c.04-.24.06-.49.06-.75 0-1.06-.4-2.03-1.06-2.79.48-.29 1.02-.46 1.56-.46Z"/></svg>
        </div>
        <div class="uc-body">
          <div class="uc-k">Resources tracked</div>
          <div class="uc-v">{{ summary.resCount }}</div>
          <div class="uc-sub">across {{ summary.taskCount }} task{{ summary.taskCount === 1 ? '' : 's' }}</div>
        </div>
      </div>
      <div class="rpu-card" [class.-danger]="summary.overDanger" [class.-ok]="!summary.overDanger">
        <div class="uc-ico" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor"><path d="M8.9 1.5c-.4-.7-1.4-.7-1.8 0L.4 13.2c-.4.66.08 1.5.9 1.5h13.4c.82 0 1.3-.84.9-1.5L8.9 1.5ZM8 5.5c.4 0 .75.34.75.75v3a.75.75 0 0 1-1.5 0v-3c0-.41.34-.75.75-.75Zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/></svg>
        </div>
        <div class="uc-body">
          <div class="uc-k">Overallocated</div>
          <div class="uc-v">{{ summary.overCount }}</div>
          <div class="uc-sub">{{ summary.overCount ? 'need levelling' : 'all within capacity' }}</div>
        </div>
      </div>
      <div class="rpu-card" [class.-danger]="summary.peakDanger">
        <div class="uc-ico" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor"><path d="M1.5 14a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v8.44l3.3-3.3a.75.75 0 0 1 1.02-.04l2.4 2.03 3.9-4.13H10.5a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V7.1l-4.4 4.66a.75.75 0 0 1-1.03.06L5.9 9.78 2.25 13.4a.75.75 0 0 1-.53.22Z"/></svg>
        </div>
        <div class="uc-body">
          <div class="uc-k">Peak utilisation</div>
          <div class="uc-v">{{ summary.peakPct }}<span class="uc-unit">%</span></div>
          <div class="uc-sub">highest single day</div>
        </div>
      </div>
      <div class="rpu-card">
        <div class="uc-ico" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="18" height="18" fill="currentColor"><path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM3 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5.5-2.5a.75.75 0 0 0-1.5 0v2.75c0 .2.08.39.22.53l1.5 1.5a.75.75 0 1 0 1.06-1.06L8.5 7.94V5.5Z"/></svg>
        </div>
        <div class="uc-body">
          <div class="uc-k">Avg utilisation</div>
          <div class="uc-v">{{ summary.avgPct }}<span class="uc-unit">%</span></div>
          <div class="uc-sub">working days in window</div>
        </div>
      </div>
    </div>

    <!-- toolbar -->
    <div class="rpu-toolbar">
      <div class="rpu-winnav">
        <button class="rpu-icon-btn" (click)="shift(-1)" aria-label="Previous week">‹</button>
        <span class="rpu-winlabel">{{ winLabel }}</span>
        <button class="rpu-icon-btn" (click)="shift(1)" aria-label="Next week">›</button>
        <button class="rpu-btn -sm" (click)="resetWindow()">Reset</button>
      </div>
      <span class="rpu-spacer"></span>
      <button class="rpu-btn -sm" [class.-primary]="overOnly" (click)="toggleOver()">
        <span class="rpu-warn icon-warning" aria-hidden="true"></span> Overallocated only
      </button>
      <div class="rpu-seg">
        <button [class.active]="mode==='day'" (click)="setMode('day')">Day</button>
        <button [class.active]="mode==='week'" (click)="setMode('week')">Week</button>
      </div>
    </div>

    <!-- legend -->
    <div class="rpu-legend">
      <span class="rpu-legend-title">Load</span>
      <span class="lg"><span class="sw rpu-heat-1"></span>≤50%</span>
      <span class="lg"><span class="sw rpu-heat-2"></span>50–85%</span>
      <span class="lg"><span class="sw rpu-heat-3"></span>85–100%</span>
      <span class="lg"><span class="sw rpu-heat-4"></span>Over 100%</span>
      <span class="lg -div"><span class="sw -nonwork"></span>Non-working</span>
      <span class="lg"><span class="sw -holiday"></span>Holiday</span>
      <span class="rpu-spacer"></span>
      <span class="rpu-muted">Numbers are allocation % of capacity</span>
    </div>

    <!-- grid -->
    <div class="rpu-gridwrap">
      <table class="rpu-grid">
        <thead>
          <tr>
            <th class="g-name">Resource</th>
            <ng-container *ngIf="mode==='day'">
              <th *ngFor="let h of dayHeaders; trackBy: trackIndex" class="hcell"
                  [class.wk-start]="h.wkStart"
                  [class.weekend]="h.weekend"
                  [class.today]="h.today">
                <div class="dow">{{ h.dow }}</div><div class="dnum">{{ h.dnum }}</div>
              </th>
            </ng-container>
            <ng-container *ngIf="mode==='week'">
              <th *ngFor="let w of weekHeaders; trackBy: trackIndex" class="hcell week wk-start"><div class="dnum">{{ w.label }}</div><div class="dow">week</div></th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let sec of viewSections; trackBy: trackSection">
            <tr class="group-row">
              <td class="g-name">{{ sec.group }}</td>
              <td [attr.colspan]="colCount"></td>
            </tr>
            <ng-container *ngFor="let res of sec.rows; trackBy: trackRow">
              <tr class="res-row">
                <td class="g-name">
                  <span class="caret" (click)="toggle(res.id)">{{ res.expanded ? '▾' : '▸' }}</span>
                  <span class="avatar" [style.background]="res.typeColor">{{ res.initials }}</span>
                  <span class="nm">{{ res.name }}<small>max {{ res.cap }}% · {{ res.calName }}</small></span>
                  <span class="peak-chip" [ngClass]="res.chipClass">{{ res.peak }}%</span>
                </td>
                <ng-container *ngIf="mode==='day'">
                  <td *ngFor="let c of res.day; trackBy: trackIndex" class="cell"
                      [ngClass]="c.cls" [attr.title]="c.title">{{ c.text }}</td>
                </ng-container>
                <ng-container *ngIf="mode==='week'">
                  <td *ngFor="let c of res.week; trackBy: trackIndex" class="cell"
                      [ngClass]="c.cls" [attr.title]="c.title">{{ c.text }}</td>
                </ng-container>
              </tr>
              <ng-container *ngIf="res.expanded">
                <tr class="asg-row" *ngFor="let sub of res.subRows; trackBy: trackSub">
                  <td class="g-name -sub">
                    <span class="dot">•</span>
                    <a class="asg-nm" [href]="sub.link" target="_blank" rel="noopener" [title]="sub.linkTitle">
                      <span class="wp-id">#{{ sub.taskId }}</span>{{ sub.taskName }}
                    </a>
                  </td>
                  <ng-container *ngIf="mode==='day'">
                    <td *ngFor="let c of sub.day; trackBy: trackIndex" class="cell" [ngClass]="c.cls">{{ c.text }}</td>
                  </ng-container>
                  <ng-container *ngIf="mode==='week'">
                    <td *ngFor="let c of sub.week; trackBy: trackIndex" class="cell" [ngClass]="c.cls">{{ c.text }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <tr *ngIf="isEmpty"><td class="rpu-empty" [attr.colspan]="colCount + 1">No work or equipment resources to display. Add resources with Max Units in Resource management.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="rpu-foot">Expand a resource to see which tasks drive its load. Load is summed from <b>Committed</b> assignments and placed only on the resource's working days.</div>
  </ng-container>
</div>
